import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef, useState } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useCharacters } from '../../../contexts/Characters'
import { capitalize } from '../../../utilities/helpers'
import { unitTypes } from '../../../utilities/constants'
import Select from '../../forms/Select/Select'

const EditCharacterInfo = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const formName = 'editCharacterInfo'
    const { character } = modal.$state.data
    const [serverOptions, setServerOptions] = useState([])
    const [allianceOptions, setAllianceOptions] = useState({})
    const noAllianceOption = { value: null, label: 'No Alliance' }

    const editCharacterInfoRef = useRef()
    editCharacterInfoRef.current = () => {
        const formValues = form.$state.value

        koalition.put(`characters/${character._id}`, formValues).then((response) => {
            modal.close()
            toaster.success('Character updated successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => editCharacterInfoRef.current(), controls: {
        name: { validators: [Validators.required], value: character.name },
        server: { validators: [Validators.required], value: character.server._id },
        alliance: { value: character.alliance?._id },
        power: { validators: [Validators.integer, Validators.min(1)], value: character.power },
        merits: { validators: [Validators.integer, Validators.min(0)], value: character.merits },
    } })

    const onServerChange = (serverId) => {
        if (serverId && !allianceOptions[serverId]) {
            koalition.get(`/servers/${serverId}/alliances`).then((response) => {
                const alliancesOptions = response.data.map((alliance) => ({ value: alliance._id, label: `${alliance.name} [${alliance.tag}]` }))
                
                setAllianceOptions((prev) => {
                    const allianceOptionsMap = { ...prev }
                    allianceOptionsMap[serverId] = [noAllianceOption, ...alliancesOptions]

                    return allianceOptionsMap
                })
            })
        }
    }

    useEffect(() => {
        koalition.get('/servers').then((response) => {
            setServerOptions(response.data.map((server) => ({ value: server._id, label: server.name })))
        }).catch((error) => {
            console.error(error)
        })
        
        modal.configure({ formName, submitLabel: 'Save' })
    }, [])

    return (
        <>
            {form.$state && (
                <>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <Input control={form.$state.controls.name} label="Name" />
                        </div>

                        <div className="col-md-2 mb-3">
                            <Select control={form.$state.controls.server} options={serverOptions} onChange={onServerChange} label="Server" />
                        </div>

                        <div className="col-md-4 mb-3">
                            <Select control={form.$state.controls.alliance} options={allianceOptions[form.$state.controls.server.value] || [noAllianceOption]} filterFrom={false} label="Alliance" />
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-sm mb-3">
                            <Input type="number" control={form.$state.controls.power} label="Power" />
                        </div>

                        <div className="col-sm mb-3">
                            <Input type="number" control={form.$state.controls.merits} label="Merits" />
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default EditCharacterInfo